"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.helpMessages = exports.groupNames = void 0;
/* ++++++++++ --------------- DEFINITION HELPERS --------------- ++++++++++ */
// used to define grouping of components
// used in conjunction with _definition files

var groupNames = {
  charts: 'Charts',
  copy: 'Copy',
  ctas: 'CTAs',
  dropdowns: 'Dropdowns',
  forms: 'Forms',
  graphics: 'Graphics',
  layouts: 'Layouts',
  lists: 'Lists',
  menus: 'Menus',
  messages: 'Messages',
  navs: 'Navigation',
  pagination: 'Pagination',
  states: 'States',
  tables: 'Tables',
  toggles: 'Toggles',
  structures: 'Structures'
}; // used to centralize help messages that are repeated throughout mulitple components

exports.groupNames = groupNames;
var helpMessages = {
  functions: {
    title: 'Demo Functions',
    desc: "This is just a function to showcase when it would be called. You'll have to attach your own function outside of the demo if you want one.",
    link: {}
  }
};
exports.helpMessages = helpMessages;